// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__Kpmbo","filesListContainer":"PosDisputesFiles_filesListContainer__3Uzg9","filesButton":"PosDisputesFiles_filesButton__329jD"};